export default "data:image/gif;base64,R0lGODlhFQAEAPAAAP///////yH5BAEAAAAALAAAAAAVAAQAAAINhI8Qya2xnINUMopZAQA7"